import { render, staticRenderFns } from "./CustomerTag.vue?vue&type=template&id=b8f1b400&scoped=true"
import script from "./CustomerTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerTag.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomerTag.vue?vue&type=style&index=0&id=b8f1b400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f1b400",
  null
  
)

export default component.exports